<script>
import { SimpleBar } from "simplebar-vue3";
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import { chatData, chatMessagesData, lineChart } from "./data-chat";
import { required, helpers } from "@vuelidate/validators";
import useVuelidate from "@vuelidate/core";
import Vue3ChartJs from "@j-t-mcc/vue3-chartjs";
import { Vue3Lottie } from 'vue3-lottie'
import 'vue3-lottie/dist/style.css'
import animationJson from '@/assets/animations/atendimento_anim.json'

export default {
  setup() {
    return { v$: useVuelidate() };
  },
  page: {
    title: "Chat",
    meta: [
      {
        name: "Atendimento",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    SimpleBar,
    Vue3ChartJs,
    Vue3Lottie,
  },
  data() {
    return {
      animationJson,
      chatData: chatData,
      chatMessagesData: chatMessagesData,
      lineChart: lineChart,
      title: "Acompanhamento de Automação (Chat)",
      items: [
        {
          text: "Atendimentos",
          href: "/atendimentos/list",
        },
        {
          text: "Acompanhamento de Automação",
          active: true,
        },
      ],
      submitted: false,
      form: {
        message: "",
      },
      username: "Clientes Testes 999",
    };
  },
  validations: {
    form: {
      message: {
        required: helpers.withMessage("Message is required", required),
      },
    },
  },
  methods: {
    /**
     * Get the name of user
     */
    chatUsername(name) {
      this.username = name;
      this.usermessage = "Olá";
      this.chatMessagesData = [];
      const currentDate = new Date();

      this.chatMessagesData.push({
        name: this.username,
        message: this.usermessage,
        time: currentDate.getHours() + ":" + currentDate.getMinutes(),
      });

      this.chatMessagesData.push({
        align: 'right',
        name: 'BIA',
        message: 'Olá, sou a Bia, inteligência artificial da _ParEmpresa08_, como posso ajudar?',
        time: currentDate.getHours() + ": " + currentDate.getMinutes(),
      });
    },

    /**
     * Char form Submit
     */
    // eslint-disable-next-line no-unused-vars
    formSubmit(e) {
      this.submitted = true;

      // stop here if form is invalid
      this.v$.$touch();

      if (this.v$.$invalid) {
        return;
      } else {
        const message = this.form.message;
        const currentDate = new Date();
        this.chatMessagesData.push({
          align: "right",
          name: "Henry Wells",
          message,
          time: currentDate.getHours() + ":" + currentDate.getMinutes(),
        });
        this.handleScroll();
      }
      this.submitted = false;
      this.form = {};
    },

    handleScroll() {
      if (this.$refs.current.$el) {
        setTimeout(() => {
          this.$refs.current.SimpleBar.value.getScrollElement().scrollTop =
              this.$refs.current.SimpleBar.value.getScrollElement().scrollHeight + 1500;
        }, 500);
      }
    },
  },
  mounted() {
    var container1 = document.querySelector(
        "#chat-list .simplebar-content-wrapper"
    );
    container1.scrollTo({ top: 500, behavior: "smooth" });

    var container2 = document.querySelector(
        "#containerElement .simplebar-content-wrapper"
    );
    container2.scrollTo({ top: 500, behavior: "smooth" });
  },
};
</script>

<template>
  <Layout>

    <span class="float-end" style="z-index: 1000; position: absolute; top: 5px; right: 320px;">
      <Vue3Lottie :animationData="animationJson" :height="300" :width="300" />
    </span>

    <PageHeader :title="title" :items="items" />


    <div class="d-lg-flex">
      <div class="chat-leftsidebar me-lg-4">
        <div class>
          <div class="py-4 border-bottom">
            <div class="d-flex">
              <div class="align-self-center me-3">
                <img
                    src="@/assets/images/users/avatar-1.jpg"
                    class="avatar-xs rounded-circle"
                    alt
                />
              </div>
              <div class="flex-grow-1">
                <h5 class="font-size-15 mt-0 mb-1">Status Bia (Automação)</h5>
                <p class="text-muted mb-0">
                  <i class="mdi mdi-circle text-success align-middle me-1"></i>
                  Ativo
                </p>
              </div>

              <b-dropdown
                  menu-class="dropdown-menu-end"
                  class="chat-noti-dropdown active"
                  right
                  variant="white"
              >
                <template v-slot:button-content>
                  <i class="bx bx-bell bx-tada"></i>
                </template>
                <b-dropdown-item>Configurações</b-dropdown-item>
                <b-dropdown-item>Interromper Automação</b-dropdown-item>
<!--                <b-dropdown-item>Something else here</b-dropdown-item>-->
              </b-dropdown>
            </div>
          </div>
        </div>

        <div class="search-box chat-search-box py-4">
          <div class="position-relative">
            <input id="inputPesquisa" type="text" class="form-control" placeholder="Enter para pesquisar..." />
            <i class="bx bx-search-alt search-icon"></i>
          </div>
        </div>

        <div class="chat-leftsidebar-nav">
          <b-tabs pills fill content-class="py-4">
            <b-tab title="Tab 1" active>
              <template v-slot:title>
                <i class="bx bx-chat font-size-20 d-sm-none"></i>
                <span class="d-none d-sm-block">Pendentes</span>
              </template>
              <b-card-text>
                <div>
<!--                  <h5 class="font-size-14 mb-3">Recent</h5>-->
                  <SimpleBar style="max-height: 410px" id="chat-list">
                    <ul class="list-unstyled chat-list">
                      <li
                          class
                          v-for="data of chatData"
                          :key="data.id"
                          @click="chatUsername(data.name)"
                          :class="{ active: username == data.name }"
                      >
                        <a href="javascript: void(0);">
                          <div class="d-flex">
                            <div class="align-self-center me-3">
                              <i
                                  :class="`mdi mdi-circle text-${data.color} font-size-10`"
                              ></i>
                            </div>
                            <div
                                class="align-self-center me-3"
                                v-if="data.image"
                            >
                              <img
                                  :src="`${data.image}`"
                                  class="rounded-circle avatar-xs"
                                  alt
                              />
                            </div>
                            <div
                                class="avatar-xs align-self-center me-3"
                                v-if="!data.image"
                            >
                              <span
                                  class="
                                  avatar-title
                                  rounded-circle
                                  bg-soft bg-primary
                                  text-primary
                                "
                              >{{ data.name.charAt(0) }}</span
                              >
                            </div>
                            <div class="flex-grow-1 overflow-hidden">
                              <h5 class="text-truncate font-size-14 mb-1">
                                {{ data.name }}
                              </h5>
                              <p class="text-truncate mb-0">
                                {{ data.message }}
                              </p>
                            </div>
                            <div class="font-size-11">{{ data.time }}</div>
                          </div>
                        </a>
                      </li>
                    </ul>
                  </SimpleBar>
                </div>
              </b-card-text>
            </b-tab>
            <b-tab>
              <template v-slot:title>
                <i class="bx bx-group font-size-20 d-sm-none"></i>
                <span class="d-none d-sm-block">Finalizados</span>
              </template>
              <b-card-text>
                <h5 class="font-size-14 mb-3">Groups</h5>
                <ul class="list-unstyled chat-list">
                  <li>
                    <a href="#">
                      <div class="d-flex align-items-center">
                        <div class="avatar-xs me-3">
                          <span
                              class="
                              avatar-title
                              rounded-circle
                              bg-soft bg-primary
                              text-primary
                            "
                          >G</span
                          >
                        </div>

                        <div class="flex-grow-1">
                          <h5 class="font-size-14 mb-0">Cliente Testes 0600</h5>
                        </div>
                      </div>
                    </a>
                  </li>

                  <li>
                    <a href="#">
                      <div class="d-flex align-items-center">
                        <div class="avatar-xs me-3">
                          <span
                              class="
                              avatar-title
                              rounded-circle
                              bg-soft bg-primary
                              text-primary
                            "
                          >R</span
                          >
                        </div>

                        <div class="flex-grow-1">
                          <h5 class="font-size-14 mb-0">Cliente Testes 0608</h5>
                        </div>
                      </div>
                    </a>
                  </li>

                  <li>
                    <a href="#">
                      <div class="d-flex align-items-center">
                        <div class="avatar-xs me-3">
                          <span
                              class="
                              avatar-title
                              rounded-circle
                              bg-soft bg-primary
                              text-primary
                            "
                          >M</span
                          >
                        </div>

                        <div class="flex-grow-1">
                          <h5 class="font-size-14 mb-0">Cliente Testes 0700</h5>
                        </div>
                      </div>
                    </a>
                  </li>

                  <li>
                    <a href="#">
                      <div class="d-flex align-items-center">
                        <div class="avatar-xs me-3">
                          <span
                              class="
                              avatar-title
                              rounded-circle
                              bg-soft bg-primary
                              text-primary
                            "
                          >A</span
                          >
                        </div>

                        <div class="flex-grow-1">
                          <h5 class="font-size-14 mb-0">Cliente Testes 0001</h5>
                        </div>
                      </div>
                    </a>
                  </li>

                  <li>
                    <a href="#">
                      <div class="d-flex align-items-center">
                        <div class="avatar-xs me-3">
                          <span
                              class="
                              avatar-title
                              rounded-circle
                              bg-soft bg-primary
                              text-primary
                            "
                          >B</span
                          >
                        </div>

                        <div class="flex-grow-1">
                          <h5 class="font-size-14 mb-0">Cliente Testes 0002</h5>
                        </div>
                      </div>
                    </a>
                  </li>
                </ul>
              </b-card-text>
            </b-tab>

          </b-tabs>
        </div>
      </div>
      <div class="w-100 user-chat">
        <div class="card">
          <div class="p-4 border-bottom">
            <div class="row">
              <div class="col-md-4 col-9">
                <h5 class="font-size-15 mb-1">{{ username }}</h5>
                <p class="text-muted mb-0">
                  <i class="mdi mdi-circle text-success align-middle me-1"></i>
                  Ativo agora
                </p>
              </div>
              <div class="col-md-8 col-3">
                <ul class="list-inline user-chat-nav text-end mb-0">
                  <li class="list-inline-item d-none d-sm-inline-block">
                    <b-dropdown
                        menu-class="dropdown-menu-md dropdown-menu-end"
                        variant="white"
                        right
                        toggle-class="nav-btn"
                    >
                      <template v-slot:button-content>
                        <i class="bx bx-search-alt-2"></i>
                      </template>
                      <form class="p-3">
                        <div class="form-group m-0">
                          <div class="input-group">
                            <input
                                id="inputPesqCli"
                                type="text"
                                class="form-control"
                                placeholder="Pesquisar..."
                                aria-label="Recipient's username"
                            />
                            <div class="input-group-append">
                              <button class="btn btn-primary" type="submit">
                                <i class="mdi mdi-magnify"></i>
                              </button>
                            </div>
                          </div>
                        </div>
                      </form>
                    </b-dropdown>
                  </li>
                  <li class="list-inline-item d-none d-sm-inline-block">
                    <b-dropdown
                        toggle-class="nav-btn"
                        menu-class="dropdown-menu-end"
                        right
                        variant="white"
                    >
                      <template v-slot:button-content>
                        <i class="bx bx-cog"></i>
                      </template>
                      <b-dropdown-item>Detalhes Cliente</b-dropdown-item>
                      <b-dropdown-item>Perfil Representante</b-dropdown-item>
                      <b-dropdown-item>Perfil Supervisor</b-dropdown-item>
                      <b-dropdown-item>Deletar</b-dropdown-item>
                    </b-dropdown>
                  </li>

                  <li class="list-inline-item">
                    <b-dropdown
                        toggle-class="nav-btn"
                        menu-class="dropdown-menu-end"
                        right
                        variant="white"
                    >
                      <template v-slot:button-content>
                        <i class="bx bx-dots-horizontal-rounded"></i>
                      </template>
                      <b-dropdown-item>Editar Automação</b-dropdown-item>
<!--                      <b-dropdown-item>Another action</b-dropdown-item>-->
<!--                      <b-dropdown-item>Something else</b-dropdown-item>-->
                    </b-dropdown>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <div class="chat-users">
            <div class="chat-conversation p-3">
              <SimpleBar
                  style="max-height: 470px"
                  id="containerElement"
                  ref="current"
              >
                <ul class="list-unstyled">
<!--                  <li>-->
<!--                    <div class="chat-day-title">-->
<!--                      <span class="title">Today</span>-->
<!--                    </div>-->
<!--                  </li>-->
                  <li v-for="data of chatMessagesData"
                      :key="data.message"
                      :class="{ right: `${data.align}` === 'right' }">

                    <div class="conversation-list">
<!--                      <b-dropdown v-if="data.align === 'right'"-->
<!--                          variant="white"-->
<!--                          menu-class="dropdown-menu-end">-->
<!--                        <template v-slot:button-content>-->
<!--                          <i class="bx bx-dots-vertical-rounded"></i>-->
<!--                        </template>-->
<!--                        <b-dropdown-item>Editar Automação</b-dropdown-item>-->
<!--                        <b-dropdown-item>Save</b-dropdown-item>-->
<!--                        <b-dropdown-item>Forward</b-dropdown-item>-->
<!--                        <b-dropdown-item>Delete</b-dropdown-item>-->
<!--                      </b-dropdown>-->
                      <div class="ctext-wrap">
                        <div class="conversation-name">{{ data.name }}</div>
                        <p>{{ data.message }}</p>
                        <p class="chat-time mb-0">
                          <i class="bx bx-time-five align-middle me-1"></i>
                          {{ data.time }}
                        </p>
                      </div>
                    </div>
                  </li>
                </ul>
              </SimpleBar>
            </div>
            <div class="p-3 chat-input-section">
              <form @submit.prevent="formSubmit" class="row">
                <div class="col">
                  <div class="position-relative">
                    <input
                        id="inputMessageBia"
                        type="text"
                        v-model="form.message"
                        class="form-control chat-input rounded"
                        placeholder="Bia, enviar mensagem..."
                        :class="{
                        'is-invalid': submitted && v$.form.message.$error,
                      }"
                    />
                    <div
                        v-if="submitted && v$.form.message.$error"
                        class="invalid-feedback"
                    >
                      <span v-if="v$.form.message.required.$message">{{
                          v$.form.message.required.$message
                        }}</span>
                    </div>
                    <div class="chat-input-links">
                      <ul class="list-inline mb-0">

                        <li class="list-inline-item">
                          <a
                              href="javascript: void(0);"
                              v-b-tooltip.hover
                              placement="top"
                              title="Imagens"
                          >
                            <i class="mdi mdi-file-image-outline"></i>
                          </a>
                        </li>
                        <li class="list-inline-item">
                          <a
                              href="javascript: void(0);"
                              v-b-tooltip.hover
                              placement="top"
                              title="Arquivos"
                          >
                            <i class="mdi mdi-file-document-outline"></i>
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div class="col-auto">
                  <button
                      type="submit"
                      disabled="true"
                      class="btn btn-primary btn-rounded chat-send w-md">
                    <span class="d-none d-sm-inline-block me-2">Enviar</span>
                    <i class="mdi mdi-send"></i>
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
<!--            <h4 class="card-title mb-4">Line Chart</h4>-->
            <div class="row text-center">
              <div class="col-sm-4">
                <h5 class="mb-0">541</h5>
                <p class="text-muted">Chamados no Ano</p>
              </div>
              <div class="col-sm-4">
                <h5 class="mb-0">41</h5>
                <p class="text-muted">Pendentes</p>
              </div>
              <div class="col-sm-4">
                <h5 class="mb-0">500</h5>
                <p class="text-muted">Finalizados</p>
              </div>
            </div>
            <!-- Line Chart -->

            <vue3-chart-js
                class="chartjs-chart"
                v-bind="{ ...lineChart }"
            ></vue3-chart-js>
          </div>
        </div>
      </div>

    </div>


  </Layout>
</template>
